export type ReducePairingOptions<
  INPUT = unknown,
  RESULT = INPUT,
  REJECT = null,
> = {
  elements: INPUT[]
  produceResult: (
    a: INPUT,
    b: INPUT,
    indexOf: { a: number; b: number },
  ) => REJECT | RESULT
  reject?: REJECT
}

export const reducePairings = <A = unknown, B = A>(
  options: ReducePairingOptions<A, B>,
): B[] => {
  const { elements, produceResult, reject = null } = options
  const results: B[] = []
  for (let i = 0; i < elements.length - 1; i++) {
    const a = elements[i]
    for (let j = i + 1; j < elements.length; j++) {
      const b = elements[j]
      const result = produceResult(a, b, { a: i, b: j })
      if (result !== reject) {
        results.push(result)
      }
    }
  }

  return results
}
